// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2wTmQ","title":"Info_title__Bf59P","links":"Info_links__g7dTD","link":"Info_link__EvuZc","logo":"Info_logo__Sbxu5"};